import { chaveDeDataDeCalendario } from '@/shared/formatters';

export const MENSAGEM_PENDENCIA_FECHADA =
  'Esta pendência não está mais aberta: foi respondida ou venceu. Nada foi publicado. Confira as pendências do processo e publique de novo.';

const ROTULOS_TIPO: Record<string, string> = {
  CONCLUSO: 'Concluso',
  MANIFESTACAO: 'Manifestação',
  DOCUMENTACAO: 'Documentação',
  PAGAMENTO: 'Pagamento',
  ESCLARECIMENTO: 'Esclarecimento',
  ASSINATURA: 'Assinatura',
  INFORMACAO: 'Informação',
  CORRECAO_DADO: 'Correção de dado',
  HABILITACAO_ADVOGADO: 'Habilitação de advogado',
};

export function rotuloPendenciaPublicacao(tipo: string): string {
  return ROTULOS_TIPO[tipo] ?? (tipo.charAt(0) + tipo.slice(1).toLowerCase()).replace(/_/g, ' ');
}

export function prazoPendenciaPublicacao(prazo: string | null): string {
  const chave = chaveDeDataDeCalendario(prazo);
  if (!chave) return 'sem prazo';
  const data = new Date(`${chave}T00:00:00Z`);
  const partes = new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: 'short',
    timeZone: 'UTC',
  }).formatToParts(data);
  const dia = partes.find((parte) => parte.type === 'day')?.value;
  const mes = partes.find((parte) => parte.type === 'month')?.value.replace('.', '');
  return `vence em ${dia} ${mes}`;
}

export function pendenciaPublicacaoFechou(erro: unknown): boolean {
  return erro instanceof Error
    ? erro.message === MENSAGEM_PENDENCIA_FECHADA
    : erro === MENSAGEM_PENDENCIA_FECHADA;
}
